'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple error label to be used on white surfaces.
 */
var ErrorLabel = function ErrorLabel(_ref) {
  var children = _ref.children;
  return children ? _react2.default.createElement(
    'div',
    { className: 'ErrorLabel' },
    _react2.default.createElement(_Icon2.default, { name: 'exclamation' }),
    children
  ) : null;
};

ErrorLabel.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ErrorLabel;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ErrorLabel/index.js
// module id = 381
// module chunks = 0